import React, { useState, useEffect } from "react";
import { Container, Row, Col } from 'react-bootstrap';
import { PROD, PIT_ROLES } from "../../../common/constants";
import { Box, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { QuickSearchToolbar } from "../../../payment/common/commonFunctions";
import { GET_CONSIGNMENT_LIST, GET_STAKEHOLDER_CATEGORY, DELETE_CONSIGNMENT, UPDATE_CONSIGNMENT, RAISE_REQUEST_FOR_CONSIGNMENT_CANCELLATION } from "../../../common/URLs";
import moment from 'moment';
import { loaderService } from "../../../common/custom-loader/loader-service";

import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import jwt from 'jwt-decode';
import { useNavigate } from "react-router-dom";
import { DialogContent, IconButton, Dialog, DialogActions, DialogTitle } from '@mui/material'; // Added DialogTitle
import { ConfirmPopover } from "../../../preregcamps/confirmPopover/confirmPopover";
import DeleteIcon from '@mui/icons-material/Delete';
import { CardContent, Card, Tooltip, Typography, Stack, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { UpdateConsignmentPopup } from "../weeklyConsignment/updateConsignmentDetails";
import { useTranslation } from "react-i18next";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { Tab } from '@mui/material';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { AddIcon, CancelIcon, UpdateIcon, ViewIcon } from "../../../common/icons";
import apiClient from "../../../axios";

function ConsignmentList() {
    const checkProd = process.env.REACT_APP_ENV === "production"
    const { t } = useTranslation();
    const { state } = useLocation();
    const [tabValue, setTabValue] = React.useState(state?.tabValue ? state?.tabValue : 'RawBamboo');
    const [consignmentListData, setConsignmentListData] = useState();
    const decoded = jwt(getLocalStorageItem('id_token'));
    const [stakeholderDetails, setStakeholderDetails] = useState();
    const navigate = useNavigate();
    const [deleteConsignmentNumbers, setDeleteConsignmentNumbers] = useState();
    const [consignmentRowDetails, setConsignmentRowDetails] = useState();
    const [consignmentToDelete, setConsignmentToDelete] = useState();
    const [isApiCalled, setIsApiCalled] = useState(false);

    const [consignmentToCancel, setConsignmentToCancel] = useState();
    const [cancelComment, setCancelComment] = useState("");
    const [cancelCommentError, setCancelCommentError] = useState(false);

    const [logModalOpen, setLogModalOpen] = useState(false);
    const handleLogModalOpen = () => setLogModalOpen(true);
    const handleLogModalClose = () => setLogModalOpen(false);
    const [logModalOpen1, setLogModalOpen1] = useState(false);
    const [logModalOpen2, setLogModalOpen2] = useState(false);
    const handleLogModalOpen1 = () => setLogModalOpen1(true);
    const handleLogModalClose1 = () => { setLogModalOpen1(false); getConsignmentList(); }
    const handleLogModalOpen2 = () => setLogModalOpen2(true);
    const handleLogModalClose2 = () => { setLogModalOpen2(false); getConsignmentList(); }

    const [logModalOpen3, setLogModalOpen3] = useState(false);
    const handleLogModalOpen3 = () => setLogModalOpen3(true);
    const handleLogModalClose3 = () => setLogModalOpen3(false);

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    const [confirmOpen2, setConfirmOpen2] = useState(false);
    const handleConfirmOpen2 = () => setConfirmOpen2(true);

    const handleConfirmClose2 = () => {
        setConfirmOpen2(false);
        setCancelComment("");
        setCancelCommentError(false);
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const columns = [
        { field: 'consignmentNumber', headerName: t('pit.consignmentNo'), width: 130 },
        { field: 'consignmentStatus', headerName: t('pit.consignmentStatus'), width: 200 },
        { field: 'deliveryChallanNo', headerName: t('pit.deliveryChallanNo'), width: 150 },
        {
            field: 'challanDate', headerName: t('pit.deliveryChallanDate'), width: 160,
            valueFormatter: params => params?.value != null ? moment(params?.value).format("DD/MM/YYYY") : " "
        },
        { field: 'pickUpLocationURN', headerName: t('pit.sourceUrn'), width: 150 },
        {
            field: 'pickUpLocationAddress', headerName: t('pit.sourceLocation'), width: 250,
            renderCell: (params) => (
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
                    {params.value}
                </div>
            ),
            valueGetter: (params) => params.value
        },
        { field: 'deliveryLocationURN', headerName: t('pit.destinationUrn'), width: 150 },
        {
            field: 'deliveryLocationAddress', headerName: t('pit.destinationLocation'), width: 250,
            renderCell: (params) => (
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
                    {params.value}
                </div>
            ),
            valueGetter: (params) => params.value
        },
        { field: 'vehicleRegistration', headerName: t('pit.vehicleNo'), width: 110 },
        { field: 'scheduledConsignmentWeight', headerName: t('pit.quantity'), width: 100 },

        {
            field: 'cancelComment', headerName: 'Cancel Comment', width: 200, hide: checkProd,
            renderCell: (params) => (
                <div style={{ whiteSpace: 'normal', wordWrap: 'break-word', width: '100%' }}>
                    {params.value ? params.value : '-'}
                </div>
            )
        },
        {
            field: t('reg.actions'), width: 160,
            renderCell: (params) => {
                return (
                    <>
                        <Tooltip title={t('pit.view')}>
                            <IconButton color="primary"
                                onClick={() => onViewClick(params)}>
                                <ViewIcon />
                            </IconButton>
                        </Tooltip>
                        {(localStorage.getItem('role') == PIT_ROLES.PitScmUser || stakeholderDetails?.category === "Transporter" || stakeholderDetails?.category === "HIT") &&
                            <>
                                <Tooltip title="Update">
                                    <IconButton color="primary"
                                        disabled={params.row.consignmentStatus !== "Created" || params.row.isConsignmentCancellationRequested === true}
                                        onClick={(e) => onUpdateConsignment(e, params.row)}>
                                        <UpdateIcon />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete">
                                    <IconButton size='small' color="error" disabled={params.row.consignmentStatus != "Created"}
                                        onClick={() => onDeleteButtonClick(params.row.consignmentNumber)} >
                                        <DeleteIcon />
                                    </IconButton>
                                </Tooltip>
                            </>
                        }
                        {
                            stakeholderDetails?.category === "Transporter" &&
                            <Tooltip title="Cancel">
                                <IconButton color="secondary"
                                    hidden={checkProd}
                                    disabled={params.row.isTripStarted === true || params.row.isConsignmentCancellationRequested === true}
                                    onClick={(e) => onCancelButtonClick(e, params.row)}>
                                    <CancelIcon />
                                </IconButton>
                            </Tooltip>
                        }

                    </>
                );
            }
        }
    ];

    useEffect(() => {
        getStakeDetails(decoded.extension_URN ? decoded.extension_URN : 'plant');
    }, [tabValue]);

    const getStakeDetails = (urn1) => {
        loaderService.showLoader();
        apiClient
            .post(GET_STAKEHOLDER_CATEGORY,
                {
                    "urn": urn1,
                    "type": ""
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token')
                    }
                }, null
            ).then((response) => {
                setStakeholderDetails(response.data);
                loaderService.hideLoader();
            }).catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }
    useEffect(() => {
        if (stakeholderDetails) {
            getConsignmentList();
        }
    }, [stakeholderDetails]);

    const getConsignmentList = () => {
        loaderService.showLoader();
        apiClient
            .post(GET_CONSIGNMENT_LIST,
                {
                    stakeHolderUrn: stakeholderDetails.urn ? stakeholderDetails.urn : "",
                    stakeHolderType: stakeholderDetails.category ? stakeholderDetails.category : "",
                    materialType: tabValue

                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token')
                    },
                },
                null
            ).then((response) => {
                setConsignmentListData(response.data.consignmentList);
                loaderService.hideLoader()
            }).catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const onViewClick = (cellValue) => {
        navigate('./ConsignmentListDetails', {
            state: { selectedRow: cellValue.row, tabValue: tabValue }
        });
    }

    const onDeleteConsignment = (consignmentNo) => {
        loaderService.showLoader();
        apiClient
            .post(
                DELETE_CONSIGNMENT,
                {
                    "consignmentNo": consignmentNo,
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                setDeleteConsignmentNumbers(response.data);
                getConsignmentList();
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    useEffect(() => {
        if (deleteConsignmentNumbers) {
            if (deleteConsignmentNumbers.isSuccess === true) {
                toast.success(deleteConsignmentNumbers?.message)
            } else {
                toast.error(deleteConsignmentNumbers?.message ? deleteConsignmentNumbers?.message : "Error")
            }
        }
    }, [deleteConsignmentNumbers]);

    const onUpdateConsignment = (e, row) => {
        setConsignmentRowDetails(row);
        handleLogModalOpen3();
    }

    const onCreateClick = () => {
        if (stakeholderDetails?.category === "HIT") {
            navigate('/consignmentCreation')
        }
        else if (stakeholderDetails?.category === "Transporter") {
            navigate('/ChippingConsignmentCreation')
        }
    }

    const onConfirmDelete = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await onDeleteConsignment(consignmentToDelete);
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setConfirmOpen(false);
            setIsApiCalled(false);
        }
    };

    const onDeleteButtonClick = (consNo) => {
        handleConfirmOpen();
        setConsignmentToDelete(consNo);
    }

    const onConfirmCancel = async () => {
        if (!cancelComment || cancelComment.trim() === "") {
            setCancelCommentError(true);
            return;
        }

        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await onCancelConsignment(consignmentToCancel, cancelComment.trim());
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            handleConfirmClose2();
            setIsApiCalled(false);
        }
    };

    const onCancelButtonClick = (e, row) => {
        setCancelComment("");
        setCancelCommentError(false);
        setConsignmentToCancel(row.consignmentNumber);
        handleConfirmOpen2();
    }

    const onCancelConsignment = (consignmentNo, commentTxt) => {
        loaderService.showLoader();
        apiClient
            .post(
                RAISE_REQUEST_FOR_CONSIGNMENT_CANCELLATION,
                {
                    "consignmentNumber": consignmentNo,
                    "comment": commentTxt
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                },
                null
            )
            .then((response) => {
                if (response.data.isSuccess === true) {
                    toast.success(response?.data?.message);
                    getConsignmentList();
                }
                else toast.error(response?.data?.message ? response?.data?.message : "Error")
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    return (
        <>
            <Container fluid>
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT49</p>}
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h5" gutterBottom>
                        {t('pit.consignmentList')}
                    </Typography>
                </Stack>
                <Card>
                    {stakeholderDetails?.category === "Transporter" || stakeholderDetails?.category === "HIT" ?
                        <Button
                            sx={{ m: 1 }}
                            display="flex"
                            justifyContent="flex-end"
                            alignItems="flex-end"
                            variant="contained"
                            color="primary"
                            startIcon={<AddIcon />}
                            onClick={() => onCreateClick()}
                        >
                            {t('pit.consignmentCreation')}
                        </Button>
                        : null
                    }
                    <>
                        <TabContext value={tabValue}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                <TabList onChange={handleTabChange}>
                                    <Tab label="Raw Bamboo" value="RawBamboo" />
                                    {stakeholderDetails?.category === "Grower" ? null : <Tab label="Chip Bamboo" value="ChipBamboo" />}
                                </TabList>
                            </Box>
                            <TabPanel value="RawBamboo">
                                <Box sx={{ height: 450, width: "100%" }}>
                                    {consignmentListData && <DataGrid
                                        rows={consignmentListData}
                                        columns={columns}
                                        getRowId={(row) => row.consignmentNumber}
                                        getRowHeight={() => 'auto'}
                                        pageSize={10}
                                        rowsPerPageOptions={[5]}
                                        components={{ Toolbar: QuickSearchToolbar }}
                                        experimentalFeatures={{ newEditingApi: true }}
                                    />}
                                </Box>
                            </TabPanel>
                            <TabPanel value="ChipBamboo">
                                <Box sx={{ height: 450, width: "100%" }}>
                                    {consignmentListData && <DataGrid
                                        rows={consignmentListData}
                                        columns={columns}
                                        getRowId={(row) => row.consignmentNumber}
                                        getRowHeight={() => 'auto'}
                                        pageSize={10}
                                        rowsPerPageOptions={[5]}
                                        components={{ Toolbar: QuickSearchToolbar }}
                                        experimentalFeatures={{ newEditingApi: true }}
                                    />}
                                </Box>
                            </TabPanel>
                        </TabContext>
                    </>
                </Card>
            </Container>

            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmDelete} onClose={handleConfirmClose} action="Delete Consignment" />

            <Dialog open={confirmOpen2} onClose={handleConfirmClose2} maxWidth="sm" fullWidth>
                <DialogTitle>Cancel Consignment</DialogTitle>
                <DialogContent dividers>
                    <Typography variant="body1" gutterBottom>
                        Are you sure you want to request cancellation for consignment <b>{consignmentToCancel}</b>?
                    </Typography>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="cancel-comment"
                        label="Reason for cancellation (Required)"
                        type="text"
                        fullWidth
                        multiline
                        rows={3}
                        variant="outlined"
                        value={cancelComment}
                        onChange={(e) => {
                            setCancelComment(e.target.value);
                            if (e.target.value.trim()) setCancelCommentError(false);
                        }}
                        required
                        error={cancelCommentError}
                        helperText={cancelCommentError ? "A valid comment is mandatory to cancel." : ""}
                        sx={{ mt: 2 }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleConfirmClose2}>Close</Button>
                    <Button
                        onClick={onConfirmCancel}
                        color="error"
                        variant="contained"
                        disabled={isApiCalled}
                    >
                        Confirm Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog maxWidth='xs' fullWidth open={logModalOpen1}>
                <DialogContent>
                    <ConfirmPopover title={deleteConsignmentNumbers?.message ? deleteConsignmentNumbers?.message : "Error"} hideLink={true} />
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleLogModalClose1}>OK</Button>
                </DialogActions>
            </Dialog>

            <Dialog maxWidth='md' fullWidth open={logModalOpen3}>
                <DialogContent>
                    <UpdateConsignmentPopup
                        row={consignmentRowDetails}
                        onClose={handleLogModalClose3}
                    />
                </DialogContent>
            </Dialog>
        </>
    )
}
export default ConsignmentList;
